import { render, staticRenderFns } from "./StatementNonauth.vue?vue&type=template&id=4de2c9b9&"
import script from "./StatementNonauth.vue?vue&type=script&lang=js&"
export * from "./StatementNonauth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports